import _ from "lodash";
import 'CssFolder/widgets.scss';

export default function WidgetContainerComponent() {
  let title;
  let links;

  return {
    view: function (vnode) {
      title = vnode.attrs.title;
      links = vnode.attrs.links;
      return [
        m('.widget-container.card', { class: vnode.attrs.class, style: vnode.attrs.style },
          [
            (title && links) &&
            m('.card-header.d-flex.justify-content-between.px-1', { style: "border: none" }, [
              m('h2.secondary-title.card-title', title),
              links &&
              m('.d-flex.no-wrap', { style: 'gap: 20px;' },
                links.map(link => [
                  m(m.route.Link, {
                    href: link.url,
                  }, link.text),
                ]),
              ),
            ]),
            m('.card-body.p-0', [
              vnode.children
            ])
          ]
        ),
      ]
    }
  }
}
